import { Col, Input, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import AppPageHeader from '@/components/_common/AppPageHeader';

import { ListSuppliersQuery } from '@/core/domain/people/Suppliers/Suppliers.types';
import { useIntl } from 'react-intl';
import ActiveExtraFilter from '../ExtraFilters/ActiveExtraFilter';
import OrderExtraFilter from '../ExtraFilters/OrderExtraFilter';

const SelectServiceReplacementFilters: React.FC<
  ExtraFiltersProps<ListSuppliersQuery>
> = ({ setQueryParams }) => {
  const intl = useIntl().formatMessage;

  return (
    <AppPageHeader
      onSearch={(value: string) =>
        setQueryParams((prev) => ({ ...prev, search: value }))
      }
      extraFilters={
        <Row gutter={[12, 12]}>
          <Col span={24} md={12} lg={8} xxl={4}>
            <ActiveExtraFilter
              onChange={(value) =>
                setQueryParams((prev) => ({
                  ...prev,
                  active: value as unknown as boolean,
                }))
              }
            />
          </Col>

          <Col span={24} md={12} lg={8} xxl={4}>
            <OrderExtraFilter
              onChange={(value) =>
                setQueryParams((prev) => ({
                  ...prev,
                  order: value,
                }))
              }
            />
          </Col>

          <Col span={24} md={12} lg={8} xxl={4}>
            <Input
              onChange={({ target: { value } }) =>
                setQueryParams((prev) => ({ ...prev, temparioCode: value }))
              }
              placeholder={intl({
                id: 'tasks.general.form.temporaryCode',
              })}
            />
          </Col>
        </Row>
      }
    />
  );
};

export default SelectServiceReplacementFilters;
